import React from "react";

const AdvancedSearchNotice = ({ active }) => {
    if (!active) return null;

    return (
        <div className="wm-advanced-search-notice" role="status">
            <i className="fa-solid fa-filter-circle-exclamation" aria-hidden="true" />
            <span><strong>Filters are active.</strong> The results on this page may be limited.</span>
        </div>
    );
};

export default AdvancedSearchNotice;
